import { BaseModel } from '@Core';

export enum Mode {
    Occupancy,
    Parking,
}

export enum EnableStatus {
    Disabled,
    Enabled,
}

export enum ImageEnhancement {
    Level0,
    Level1,
}

export enum PostType {
    HTTP,
    TCP,
    MQTT,
}

export enum PeriodicReport {
    Disabled,
    Enabled,
}

export enum HttpMethod {
    Get,
    Post,
}

export enum Snapshot {
    Disabled,
    Enabled,
}

export enum MaxParkingUnit {
    Minutes,
    Hours,
    Days,
}

export interface LprArea {
    Name: string;
    PlgX: string;
    PlgY: string;
}

export interface HttpPost {
    Enable: EnableStatus;
    Method: HttpMethod;
    Snapshot: Snapshot;
    Url: string;
    Username: string;
    Password: string;
}

export interface MQTT {
    Topic: string;
    Port: number;
    Host: string;
    User: string;
    Password: string;
    Snapshot: Snapshot;
    Enable: EnableStatus;
}

export interface PMC8266ParkingSpaceDetection extends BaseModel {
    Mode: Mode;
    Enable: EnableStatus;
    ImageEnhancement: ImageEnhancement;
    DetectionSensitivity: number;
    OccupancySensitivity: number;
    OccupancyDuration: number;
    DepartureDuration: number;
    Country: CountryCode;
    LprLicense: string;
    LprVersion: number;
    LprArea: LprArea[];
    PostType: PostType;
    PeriodicReport: PeriodicReport;
    Period: number;
    TcpPort: number;
    HttpPost: HttpPost[];
    MQTT: MQTT;
    TimeoutAlarm: number;
    MaxParkingTime: number;
    MaxParkingUnit: MaxParkingUnit;
    SendToPlatform: number;
}

export enum CountryCode {
    General = 1,
    Albania = 24,
    Armenia = 25,
    Austria = 26,
    Azerbaijan = 27,
    Belarus = 28,
    Belgium = 29,
    BosniaAndHerzegovina = 30,
    Bulgaria = 31,
    Croatia = 32,
    Cyprus = 33,
    Czech = 34,
    Denmark = 35,
    Estonia = 36,
    Finland = 37,
    France = 38,
    Georgia = 39,
    Germany = 40,
    Greece = 41,
    Hungary = 42,
    Iceland = 43,
    Ireland = 44,
    Italy = 45,
    Kazakhstan = 46,
    Kyrgyzstan = 47,
    Latvia = 48,
    Lithuania = 49,
    Luxembourg = 50,
    Macedonia = 51,
    Malta = 52,
    Moldova = 53,
    Montenegro = 54,
    Netherlands = 55,
    Norway = 56,
    Poland = 57,
    Portugal = 58,
    Romania = 59,
    Russian = 60,
    Serbia = 61,
    Slovakia = 62,
    Slovenia = 63,
    Spain = 64,
    Sweden = 65,
    Switzerland = 66,
    Tajikistan = 67,
    Turkey = 68,
    Turkmenistan = 69,
    UK = 70,
    Ukraine = 71,
    Uzbekistan = 72,
    VaticanCity = 73,
}
